export default "__VITE_PUBLIC_ASSET__e82ad7b5__"